export default "__VITE_ASSET__C21nNBad__"